import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options) => {
  const response = await api.get(`/kam/deal-settings`, options);

  return response;
};

export const get = async ({ _id, buyer_id, seller_id, ...rest }) => {
  const response = await api.get(`/kam/deal-settings/${_id}`, {
    params: {
      buyer: buyer_id,
      seller: seller_id,
      ...rest,
    },
  });

  return response;
};

export const post = async (dealSetting, options) => {
  const response = await api.post(
    "/kam/deal-settings",
    {
      dealSetting,
    },
    options,
  );

  return response;
};

export const put = async (dealSetting, options) => {
  const response = await api.put(
    "/kam/deal-settings",
    {
      dealSetting,
    },
    options,
  );

  return response;
};

export const putStatus = async (payload) => {
  const response = await api.put("/kam/deal-settings-status", payload);

  return response;
};

export const putApproversDealSettingStatus = async (
  dealSetting,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.put(
    "/kam/deal-settings/mark-approver-status",
    dealSetting,
    { params: { showMessage, ...restParams }, ...restOptions },
  );

  return response;
};
